module.exports = __webpack_public_path__ + "a1fbf4cf368a5b5ff2f20fae4ffc235f.jpg";